var _g, _g2, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g4, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g5, _path70, _path71, _rect2, _rect3, _rect4, _rect5, _g6, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 400,
    viewBox: "0 0 246 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150.67C0 72.6869 88.0246 9.39917 123 9.39917C151.43 9.39917 246 72.6869 246 150.67V400H0V150.67Z",
    fill: "url(#paint0_linear_4_202046)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 150.67C16.2188 72.6869 88.0257 9.39917 122.903 9.39917C151.333 9.39917 233.203 72.6869 233.203 150.67V400H16.2188V150.67Z",
    fill: "url(#paint1_linear_4_202046)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8086 150.67C20.8086 72.6869 93.2994 9.39917 122.022 9.39917C145.372 9.39917 223.236 72.6869 223.236 150.67V400H20.8086V150.67Z",
    fill: "url(#paint2_linear_4_202046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1934 150.67C34.1934 72.6869 93.2998 9.39917 122.023 9.39917C145.372 9.39917 212.783 72.6869 212.783 150.67V400H34.1934V150.67Z",
    fill: "url(#paint3_linear_4_202046)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 351.898C129.965 351.898 136.483 325.58 136.483 293.116C136.483 260.653 129.965 234.335 121.926 234.335C113.886 234.335 107.369 260.653 107.369 293.116C107.369 325.58 113.886 351.898 121.926 351.898Z",
    fill: "url(#paint4_linear_4_202046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 330.834C127.592 330.834 132.184 312.193 132.184 289.198C132.184 266.202 127.592 247.561 121.926 247.561C116.261 247.561 111.668 266.202 111.668 289.198C111.668 312.193 116.261 330.834 121.926 330.834Z",
    fill: "url(#paint5_linear_4_202046)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 357.09C131.207 357.09 138.731 326.694 138.731 289.198C138.731 251.702 131.207 221.305 121.927 221.305C112.646 221.305 105.123 251.702 105.123 289.198C105.123 326.694 112.646 357.09 121.927 357.09Z",
    fill: "url(#paint6_linear_4_202046)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.0586,
    y: 185.161,
    width: 105.512,
    height: 207.693,
    fill: "url(#pattern0_4_202046)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.1 100.021H120.755C120.755 100.021 56.4711 129.607 101.412 252.949C102.486 255.497 111.279 257.554 121.928 257.554C132.577 257.554 141.369 255.595 142.444 252.949C187.385 129.607 123.1 100.021 123.1 100.021Z",
    fill: "url(#paint7_linear_4_202046)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.41 252.852C101.801 253.635 102.68 254.125 103.462 254.517C104.243 254.909 105.123 255.203 106.002 255.497C107.76 255.986 109.519 256.378 111.278 256.574C114.795 257.064 118.409 257.26 122.024 257.26C125.639 257.162 129.156 256.966 132.673 256.476C134.432 256.182 136.19 255.791 137.851 255.301C138.73 255.007 139.512 254.713 140.293 254.321C141.075 253.929 141.857 253.439 142.15 252.754L142.247 252.558H142.443L142.15 252.754C146.741 239.626 150.845 226.302 153.678 212.782C156.511 199.263 158.172 185.351 157.879 171.538C157.683 164.582 157.097 157.724 155.729 150.866C154.362 144.106 152.408 137.445 149.672 131.077C146.937 124.709 143.224 118.83 138.828 113.442C136.581 110.797 134.236 108.25 131.598 105.997C128.961 103.743 126.225 101.686 123.099 100.021C126.225 101.588 129.058 103.645 131.696 105.801C134.334 108.054 136.776 110.503 139.121 113.148C143.615 118.439 147.328 124.415 150.258 130.783C153.092 137.151 155.241 143.812 156.609 150.67C157.976 157.528 158.563 164.484 158.856 171.44L158.953 176.632C158.953 178.395 158.856 180.159 158.758 181.824L158.66 184.469C158.563 185.351 158.563 186.233 158.465 187.115L157.976 192.307C157.781 194.07 157.488 195.736 157.293 197.499C156.999 199.263 156.902 200.928 156.511 202.692L155.534 207.786C155.241 209.451 154.948 211.215 154.557 212.88C151.626 226.498 147.621 239.822 142.736 252.949L142.638 253.145H142.443L142.736 252.949C142.247 253.929 141.368 254.419 140.586 254.811C139.707 255.203 138.926 255.497 138.046 255.791C136.288 256.28 134.529 256.672 132.771 256.868C129.156 257.358 125.639 257.554 122.024 257.554C118.409 257.554 114.795 257.26 111.278 256.672C109.519 256.378 107.76 255.986 106.002 255.497C105.123 255.203 104.341 254.909 103.462 254.517C102.68 254.223 101.801 253.635 101.41 252.852Z",
    fill: "url(#paint8_linear_4_202046)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.124 242.859C105.222 242.565 105.515 242.369 105.808 242.565C112.06 246.288 121.342 245.21 128.18 244.328C134.14 243.642 140.979 242.565 146.743 240.018C182.793 127.55 123.002 100.021 123.002 100.021H120.658C120.658 100.021 56.3734 129.607 101.314 252.949C101.9 254.321 104.538 255.497 108.543 256.28C105.71 252.264 103.561 247.757 105.124 242.859Z",
    fill: "url(#paint9_linear_4_202046)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.588 10.3792H120.169C120.169 10.3792 26.6729 53.3874 92.0319 232.67C93.5951 236.393 106.296 239.332 121.829 239.332C137.363 239.332 150.064 236.393 151.627 232.67C217.084 53.3874 123.588 10.3792 123.588 10.3792Z",
    fill: "url(#paint10_linear_4_202046)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.266 10.3792C120.266 10.3792 26.7706 53.3874 92.1296 232.67C93.6927 236.393 106.393 239.332 121.927 239.332V10.3792H120.266Z",
    fill: "url(#paint11_linear_4_202046)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1884 230.71C34.2949 56.1304 125.641 14.2979 125.641 14.2979H122.808C122.808 14.2979 31.364 56.2284 95.3552 230.71C96.9184 234.335 109.326 237.176 124.469 237.176C124.86 237.176 125.153 237.176 125.543 237.176C111.182 236.98 99.5562 234.237 98.1884 230.71Z",
    fill: "url(#paint12_linear_4_202046)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7501 221.305C99.9455 221.697 100.141 221.991 100.532 222.383C101.118 221.795 101.606 221.109 102.095 220.326C42.4022 56.3263 128.375 16.845 128.375 16.845H125.64C125.737 16.845 39.3736 56.4243 99.7501 221.305Z",
    fill: "url(#paint13_linear_4_202046)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.221 17.7268H118.997C118.997 17.7268 118.411 18.0207 117.434 18.6085C129.059 25.1724 198.326 71.6095 142.053 225.714C140.685 228.947 130.427 231.494 117.434 231.886C118.508 231.886 119.583 231.886 120.658 231.886C135.117 231.886 147.036 229.143 148.501 225.616C209.659 57.9919 122.221 17.7268 122.221 17.7268Z",
    fill: "url(#paint14_linear_4_202046)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.725 197.793C150.162 201.516 137.462 204.455 121.928 204.455C106.394 204.455 93.6935 201.516 92.1304 197.793C78.4529 160.173 71.7118 128.627 69.6602 102.176C66.827 134.407 71.8095 176.926 92.1304 232.572C93.6935 236.295 106.394 239.234 121.928 239.234C137.462 239.234 150.162 236.295 151.725 232.572C172.046 176.828 177.029 134.309 174.196 102.176C172.144 128.627 165.403 160.271 151.725 197.793Z",
    fill: "url(#paint15_linear_4_202046)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.368 46.7255C143.42 19.4902 123.588 10.3792 123.588 10.3792H120.169C120.169 10.3792 100.434 19.4902 85.3887 46.7255C95.256 42.8068 107.957 40.4555 121.83 40.4555C135.8 40.3575 148.501 42.7088 158.368 46.7255Z",
    fill: "url(#paint16_linear_4_202046)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.97 43.4924C140.781 19.4901 123.391 11.5547 123.391 11.5547H120.362C120.362 11.5547 102.972 19.5881 89.7832 43.4924C98.4782 40.0635 109.616 37.9082 121.828 37.9082C134.137 38.0062 145.275 40.0635 153.97 43.4924Z",
    fill: "url(#paint17_linear_4_202046)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.173 39.7698C145.863 40.6515 150.161 41.9251 153.972 43.4926C141.564 20.8619 125.346 12.5345 123.588 11.6528C131.306 19.6863 137.265 29.3851 141.173 39.7698Z",
    fill: "url(#paint18_linear_4_202046)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.882 25.4665C108.054 22.5274 109.52 19.9802 111.376 17.531C105.221 22.4294 96.917 30.6588 89.8828 43.4927C93.693 42.0232 97.9916 40.7496 102.583 39.7699C103.658 34.9694 104.928 30.071 106.882 25.4665Z",
    fill: "url(#paint19_linear_4_202046)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.882 26.0543C123.393 23.0173 122.905 19.7843 122.025 16.8452C121.537 15.2777 120.951 13.8082 120.462 12.2407C116.164 20.4701 113.624 29.2873 112.451 38.3983C115.48 38.1044 118.606 38.0065 121.83 38.0065C122.905 38.0065 123.979 38.0065 125.054 38.1044C124.956 33.9898 124.566 30.071 123.882 26.0543Z",
    fill: "url(#paint20_linear_4_202046)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 128.04C139.029 128.04 152.895 114.135 152.895 96.9835C152.895 79.8318 139.029 65.9275 121.925 65.9275C104.821 65.9275 90.9551 79.8318 90.9551 96.9835C90.9551 114.135 104.821 128.04 121.925 128.04Z",
    fill: "url(#paint21_linear_4_202046)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 122.945C140.001 122.945 154.654 108.251 154.654 90.1256C154.654 71.9999 140.001 57.3062 121.926 57.3062C103.85 57.3062 89.1973 71.9999 89.1973 90.1256C89.1973 108.251 103.85 122.945 121.926 122.945Z",
    fill: "url(#paint22_linear_4_202046)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 122.161C139.571 122.161 153.874 107.819 153.874 90.1257C153.874 72.4328 139.571 58.09 121.927 58.09C104.284 58.09 89.9805 72.4328 89.9805 90.1257C89.9805 107.819 104.284 122.161 121.927 122.161Z",
    fill: "url(#paint23_linear_4_202046)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 118.047C137.303 118.047 149.769 105.546 149.769 90.1256C149.769 74.7053 137.303 62.2046 121.926 62.2046C106.548 62.2046 94.082 74.7053 94.082 90.1256C94.082 105.546 106.548 118.047 121.926 118.047Z",
    fill: "url(#paint24_radial_4_202046)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 121.182C139.029 121.182 152.895 107.277 152.895 90.1256C152.895 72.9738 139.029 59.0696 121.925 59.0696C104.821 59.0696 90.9551 72.9738 90.9551 90.1256C90.9551 107.277 104.821 121.182 121.925 121.182Z",
    stroke: "url(#paint25_linear_4_202046)",
    strokeWidth: 0.2147,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 117.263C136.871 117.263 148.987 105.113 148.987 90.1257C148.987 75.1382 136.871 62.9884 121.925 62.9884C106.979 62.9884 94.8633 75.1382 94.8633 90.1257C94.8633 105.113 106.979 117.263 121.925 117.263Z",
    fill: "url(#paint26_radial_4_202046)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.925 117.263C136.871 117.263 148.987 105.113 148.987 90.1257C148.987 75.1382 136.871 62.9884 121.925 62.9884C106.979 62.9884 94.8633 75.1382 94.8633 90.1257C94.8633 105.113 106.979 117.263 121.925 117.263Z",
    fill: "url(#paint27_radial_4_202046)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M96.1348 90.1257C96.1348 75.8223 107.663 64.262 121.927 64.262C136.19 64.262 147.719 75.8223 147.719 90.1257C147.719 104.429 136.874 86.9907 122.611 86.9907C108.347 86.9907 96.1348 104.429 96.1348 90.1257Z",
    fill: "url(#paint28_linear_4_202046)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M121.925 67.201C135.602 67.201 146.837 77.9775 147.619 91.4972C147.619 91.1053 147.619 90.6155 147.619 90.0276C147.619 75.7242 136.091 64.1639 121.827 64.1639C107.563 64.1639 96.0352 75.7242 96.0352 90.0276C96.0352 90.5175 96.0351 91.0073 96.1328 91.3992C97.0121 77.9775 108.247 67.201 121.925 67.201Z",
    fill: "url(#paint29_linear_4_202046)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.925 113.344C107.662 113.344 95.9379 102.274 94.961 88.1663C94.961 88.852 94.8633 89.4399 94.8633 90.1256C94.8633 105.115 106.978 117.263 121.925 117.263C136.873 117.263 148.987 105.115 148.987 90.1256C148.987 89.4399 148.987 88.852 148.89 88.1663C147.913 102.274 136.189 113.344 121.925 113.344Z",
    fill: "url(#paint30_linear_4_202046)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 170.264C131.261 170.264 138.828 162.676 138.828 153.315C138.828 143.955 131.261 136.367 121.927 136.367C112.592 136.367 105.025 143.955 105.025 153.315C105.025 162.676 112.592 170.264 121.927 170.264Z",
    fill: "url(#paint31_linear_4_202046)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 167.521C131.801 167.521 139.806 159.494 139.806 149.593C139.806 139.691 131.801 131.664 121.927 131.664C112.053 131.664 104.049 139.691 104.049 149.593C104.049 159.494 112.053 167.521 121.927 167.521Z",
    fill: "url(#paint32_linear_4_202046)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.927 167.129C131.585 167.129 139.415 159.278 139.415 149.593C139.415 139.908 131.585 132.056 121.927 132.056C112.269 132.056 104.439 139.908 104.439 149.593C104.439 159.278 112.269 167.129 121.927 167.129Z",
    fill: "url(#paint33_linear_4_202046)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.926 164.876C130.343 164.876 137.167 158.033 137.167 149.593C137.167 141.152 130.343 134.309 121.926 134.309C113.509 134.309 106.686 141.152 106.686 149.593C106.686 158.033 113.509 164.876 121.926 164.876Z",
    fill: "url(#paint34_radial_4_202046)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.543 152.515C140.147 143.294 133.992 134.516 124.797 132.908C115.602 131.299 106.847 137.471 105.244 146.692C103.64 155.913 109.794 164.691 118.99 166.3C128.185 167.908 136.939 161.736 138.543 152.515Z",
    stroke: "url(#paint35_linear_4_202046)",
    strokeWidth: 0.1172,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 164.386C130.075 164.386 136.68 157.763 136.68 149.593C136.68 141.422 130.075 134.799 121.928 134.799C113.781 134.799 107.176 141.422 107.176 149.593C107.176 157.763 113.781 164.386 121.928 164.386Z",
    fill: "url(#paint36_radial_4_202046)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 164.386C130.075 164.386 136.68 157.763 136.68 149.593C136.68 141.422 130.075 134.799 121.928 134.799C113.781 134.799 107.176 141.422 107.176 149.593C107.176 157.763 113.781 164.386 121.928 164.386Z",
    fill: "url(#paint37_radial_4_202046)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M107.859 149.593C107.859 141.853 114.112 135.485 121.928 135.485C129.646 135.485 135.996 141.755 135.996 149.593C135.996 157.332 130.037 147.829 122.318 147.829C114.503 147.927 107.859 157.43 107.859 149.593Z",
    fill: "url(#paint38_linear_4_202046)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.928 162.328C114.112 162.328 107.762 156.254 107.176 148.613C107.176 149.005 107.176 149.299 107.176 149.69C107.176 157.822 113.819 164.484 121.928 164.484C130.037 164.484 136.68 157.822 136.68 149.69C136.68 149.299 136.68 149.005 136.68 148.613C136.094 156.254 129.744 162.328 121.928 162.328Z",
    fill: "url(#paint39_linear_4_202046)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 44.7664C123.394 45.746 122.612 46.5298 121.635 46.5298C120.659 46.5298 119.877 45.746 119.877 44.7664C119.877 43.7867 120.659 43.0029 121.635 43.0029C122.612 43.0029 123.394 43.7867 123.394 44.7664Z",
    fill: "#80A7C4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 44.6682C123.394 45.6479 122.612 46.4317 121.635 46.4317C120.659 46.4317 119.877 45.6479 119.877 44.6682C119.877 43.6885 120.659 42.9048 121.635 42.9048C122.612 42.9048 123.394 43.6885 123.394 44.6682Z",
    fill: "#AECBE6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 43.2966C123.101 43.5905 123.296 43.9824 123.296 44.4723C123.296 45.4519 122.515 46.2357 121.538 46.2357C121.049 46.2357 120.658 46.0398 120.365 45.7458C120.658 46.1377 121.147 46.3337 121.733 46.3337C122.71 46.3337 123.492 45.5499 123.492 44.5702C123.394 44.0804 123.198 43.6885 122.808 43.2966Z",
    fill: "#8AB9DB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 43.1007C122.417 43.1007 123.101 43.7865 123.101 44.5702C123.101 45.354 122.417 44.6682 121.635 44.6682C120.854 44.6682 120.17 45.452 120.17 44.5702C120.17 43.6885 120.854 43.1007 121.635 43.1007Z",
    fill: "url(#paint40_linear_4_202046)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 52.1138C123.394 53.0935 122.612 53.8772 121.635 53.8772C120.659 53.8772 119.877 53.0935 119.877 52.1138C119.877 51.1341 120.659 50.3503 121.635 50.3503C122.612 50.3503 123.394 51.1341 123.394 52.1138Z",
    fill: "#80A7C4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 51.9179C123.394 52.8975 122.612 53.6813 121.635 53.6813C120.659 53.6813 119.877 52.8975 119.877 51.9179C119.877 50.9382 120.659 50.1544 121.635 50.1544C122.612 50.1544 123.394 50.9382 123.394 51.9179Z",
    fill: "#AECBE6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 50.6443C123.101 50.9382 123.296 51.3301 123.296 51.8199C123.296 52.7996 122.515 53.5833 121.538 53.5833C121.049 53.5833 120.658 53.3874 120.365 53.0935C120.658 53.4854 121.147 53.6813 121.733 53.6813C122.71 53.6813 123.492 52.8976 123.492 51.9179C123.394 51.428 123.198 50.9382 122.808 50.6443Z",
    fill: "#8AB9DB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 50.4482C122.417 50.4482 123.101 51.134 123.101 51.9178C123.101 52.7015 122.417 52.0157 121.635 52.0157C120.854 52.0157 120.17 52.7995 120.17 51.9178C120.17 51.0361 120.854 50.4482 121.635 50.4482Z",
    fill: "url(#paint41_linear_4_202046)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 173.595C123.394 174.575 122.612 175.358 121.635 175.358C120.659 175.358 119.877 174.575 119.877 173.595C119.877 172.615 120.659 171.831 121.635 171.831C122.612 171.831 123.394 172.615 123.394 173.595Z",
    fill: "#80A7C4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 173.497C123.394 174.477 122.612 175.26 121.635 175.26C120.659 175.26 119.877 174.477 119.877 173.497C119.877 172.517 120.659 171.733 121.635 171.733C122.612 171.733 123.394 172.517 123.394 173.497Z",
    fill: "#AECBE6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 172.125C123.101 172.419 123.296 172.811 123.296 173.301C123.296 174.281 122.515 175.064 121.538 175.064C121.049 175.064 120.658 174.868 120.365 174.574C120.658 174.966 121.147 175.162 121.733 175.162C122.71 175.162 123.492 174.379 123.492 173.399C123.394 172.909 123.198 172.419 122.808 172.125Z",
    fill: "#8AB9DB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 171.929C122.417 171.929 123.101 172.615 123.101 173.399C123.101 174.183 122.417 173.497 121.635 173.497C120.854 173.497 120.17 174.281 120.17 173.399C120.17 172.615 120.854 171.929 121.635 171.929Z",
    fill: "url(#paint42_linear_4_202046)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 128.137C123.394 129.117 122.612 129.901 121.635 129.901C120.659 129.901 119.877 129.117 119.877 128.137C119.877 127.158 120.659 126.374 121.635 126.374C122.612 126.374 123.394 127.158 123.394 128.137Z",
    fill: "#80A7C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 127.941C123.394 128.921 122.612 129.705 121.635 129.705C120.659 129.705 119.877 128.921 119.877 127.941C119.877 126.962 120.659 126.178 121.635 126.178C122.612 126.178 123.394 126.962 123.394 127.941Z",
    fill: "#AECBE6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 126.668C123.101 126.962 123.296 127.354 123.296 127.843C123.296 128.823 122.515 129.607 121.538 129.607C121.049 129.607 120.658 129.411 120.365 129.117C120.658 129.509 121.147 129.705 121.733 129.705C122.71 129.705 123.492 128.921 123.492 127.941C123.394 127.451 123.198 126.962 122.808 126.668Z",
    fill: "#8AB9DB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 126.472C122.417 126.472 123.101 127.158 123.101 127.941C123.101 128.725 122.417 128.039 121.635 128.039C120.854 128.039 120.17 128.823 120.17 127.941C120.17 127.158 120.854 126.472 121.635 126.472Z",
    fill: "url(#paint43_linear_4_202046)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 180.942C123.394 181.922 122.612 182.706 121.635 182.706C120.659 182.706 119.877 181.922 119.877 180.942C119.877 179.963 120.659 179.179 121.635 179.179C122.612 179.179 123.394 179.963 123.394 180.942Z",
    fill: "#80A7C4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123.394 180.746C123.394 181.726 122.612 182.51 121.635 182.51C120.659 182.51 119.877 181.726 119.877 180.746C119.877 179.767 120.659 178.983 121.635 178.983C122.612 178.983 123.394 179.767 123.394 180.746Z",
    fill: "#AECBE6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.808 179.473C123.101 179.767 123.296 180.159 123.296 180.649C123.296 181.628 122.515 182.412 121.538 182.412C121.049 182.412 120.658 182.216 120.365 181.922C120.658 182.314 121.147 182.51 121.733 182.51C122.71 182.51 123.492 181.726 123.492 180.746C123.394 180.257 123.198 179.767 122.808 179.473Z",
    fill: "#8AB9DB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 179.277C122.417 179.277 123.101 179.963 123.101 180.746C123.101 181.53 122.417 180.844 121.635 180.844C120.854 180.844 120.17 181.628 120.17 180.746C120.17 179.963 120.854 179.277 121.635 179.277Z",
    fill: "url(#paint44_linear_4_202046)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.635 185.449C121.635 185.449 113.819 182.02 107.859 238.352C107.859 238.352 120.951 240.605 135.996 238.352C135.996 238.352 130.134 187.408 121.635 185.449Z",
    fill: "url(#paint45_linear_4_202046)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M121.634 254.517C126.059 254.517 129.645 239.077 129.645 220.032C129.645 200.986 126.059 185.547 121.634 185.547C117.21 185.547 113.623 200.986 113.623 220.032C113.623 239.077 117.21 254.517 121.634 254.517Z",
    fill: "url(#paint46_linear_4_202046)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.34 247.169C124.362 247.169 126.811 234.142 126.811 218.073C126.811 202.003 124.362 188.976 121.34 188.976C118.319 188.976 115.869 202.003 115.869 218.073C115.869 234.142 118.319 247.169 121.34 247.169Z",
    fill: "url(#paint47_linear_4_202046)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6479 157.038C78.6479 157.038 95.0609 167.521 101.02 236.589C101.02 236.589 95.354 235.903 94.0839 232.572C94.0839 232.572 71.8091 172.713 73.5677 158.802L78.6479 157.038Z",
    fill: "url(#paint48_linear_4_202046)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6468 157.038C77.7676 155.863 75.8136 156.352 74.4459 156.94L30.4824 176.044C28.3331 177.024 27.063 179.375 27.5515 181.726L46.9931 270.486C47.2862 271.955 48.2632 273.131 49.5333 273.817C50.2171 274.209 50.9987 274.405 51.7803 274.405C52.4642 274.405 53.0503 274.307 53.7342 274.013L61.2568 270.878C63.1131 270.094 64.2854 268.33 64.2854 266.371L64.9693 213.86L87.8303 210.627C89.1981 210.431 90.4681 209.647 91.2497 208.472C91.3474 208.374 96.8184 182.706 78.6468 157.038Z",
    fill: "url(#paint49_linear_4_202046)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4457 156.94C63.406 161.937 52.2686 166.835 41.2289 171.733L32.9247 175.358L30.8731 176.24C30.1892 176.534 29.603 176.926 29.1145 177.416C28.1376 178.395 27.7468 179.865 27.9422 181.236L31.85 198.969L39.5681 234.629L43.3782 252.46L47.0907 270.29L42.9874 252.558L38.9819 234.825L31.0685 199.263L27.2583 181.432C26.9652 179.767 27.5514 178.101 28.7237 176.828C29.3099 176.24 29.9938 175.75 30.7754 175.456L32.827 174.575L41.2289 170.95C52.0732 166.345 63.3083 161.545 74.4457 156.94Z",
    fill: "#0E3F54"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2277 167.521L32.9243 178.493C30.9704 179.375 29.798 181.53 30.2865 183.686L48.0673 264.706L58.2277 167.521Z",
    fill: "url(#paint50_linear_4_202046)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6478 157.038C77.9639 155.765 75.8146 156.352 74.4468 156.94L72.786 157.724C92.1299 184.959 85.4866 204.945 85.4866 204.945C84.705 206.12 83.4349 206.904 82.0672 207.1L59.2062 210.333L58.5223 262.844C58.5223 264.804 57.3499 266.567 55.4937 267.351L47.9711 270.486C47.678 270.584 47.3849 270.682 47.0918 270.78C47.4826 272.151 48.3619 273.229 49.6319 273.915C50.3158 274.307 51.0974 274.503 51.8789 274.503C52.5628 274.503 53.149 274.405 53.8329 274.111L61.3555 270.976C63.2117 270.192 64.3841 268.428 64.3841 266.469L65.068 213.958L87.929 210.725C89.2967 210.529 90.5668 209.745 91.3484 208.57C91.3484 208.374 94.1816 184.861 78.6478 157.038Z",
    fill: "url(#paint51_linear_4_202046)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1378 166.541L70.149 163.21L66.1434 206.61H59.4023L62.1378 166.541Z",
    fill: "url(#paint52_linear_4_202046)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M164.525 157.038C164.525 157.038 148.112 167.521 142.152 236.589C142.152 236.589 147.819 235.903 149.089 232.572C149.089 232.572 171.364 172.713 169.605 158.802L164.525 157.038Z",
    fill: "url(#paint53_linear_4_202046)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M164.525 157.038C165.404 155.863 167.358 156.352 168.725 156.94L212.787 176.044C214.936 177.024 216.206 179.375 215.718 181.726L196.276 270.486C195.983 271.955 195.006 273.131 193.736 273.817C193.052 274.209 192.27 274.405 191.489 274.405C190.805 274.405 190.219 274.307 189.535 274.013L182.012 270.878C180.156 270.094 178.984 268.33 178.984 266.371L178.3 213.86L155.439 210.627C154.071 210.431 152.801 209.647 152.019 208.472C151.922 208.374 146.353 182.706 164.525 157.038Z",
    fill: "url(#paint54_linear_4_202046)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M168.727 156.94C179.962 161.545 191.099 166.345 202.236 171.048L210.638 174.673L212.69 175.554C213.374 175.848 214.155 176.338 214.742 176.926C215.914 178.101 216.403 179.865 216.207 181.53L212.397 199.361L204.484 234.923L200.478 252.655L196.375 270.388L200.087 252.558L203.897 234.727L211.615 199.067L215.523 181.334C215.719 179.963 215.328 178.493 214.351 177.514C213.862 177.024 213.276 176.632 212.592 176.338L210.541 175.456L202.236 171.831C190.904 166.835 179.766 161.937 168.727 156.94Z",
    fill: "#0E3F54"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.041 167.521L210.344 178.493C212.298 179.375 213.471 181.53 212.982 183.686L195.201 264.706L185.041 167.521Z",
    fill: "url(#paint55_linear_4_202046)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M164.524 157.038C165.208 155.765 167.357 156.352 168.725 156.94L170.386 157.724C151.042 184.959 157.685 204.945 157.685 204.945C158.467 206.12 159.737 206.904 161.104 207.1L183.965 210.333L184.649 262.844C184.649 264.804 185.822 266.567 187.678 267.351L195.201 270.486C195.494 270.584 195.787 270.682 196.08 270.78C195.689 272.151 194.81 273.229 193.54 273.915C192.856 274.307 192.074 274.503 191.293 274.503C190.609 274.503 190.023 274.405 189.339 274.111L181.816 270.976C179.96 270.192 178.788 268.428 178.788 266.469L178.104 213.958L155.243 210.725C153.875 210.529 152.605 209.745 151.823 208.57C151.921 208.374 149.088 184.861 164.524 157.038Z",
    fill: "url(#paint56_linear_4_202046)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M181.132 166.541L173.023 163.21L177.029 206.61H183.868L181.132 166.541Z",
    fill: "url(#paint57_linear_4_202046)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.964 100.706C137.389 100.706 140.975 96.057 140.975 90.3217C140.975 84.5864 137.389 79.937 132.964 79.937C128.54 79.937 124.953 84.5864 124.953 90.3217C124.953 96.057 128.54 100.706 132.964 100.706Z",
    fill: "url(#paint58_linear_4_202046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.965 96.9836C136.095 96.9836 138.632 93.694 138.632 89.636C138.632 85.578 136.095 82.2883 132.965 82.2883C129.836 82.2883 127.299 85.578 127.299 89.636C127.299 93.694 129.836 96.9836 132.965 96.9836Z",
    fill: "url(#paint59_linear_4_202046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.965 101.686C138.037 101.686 142.148 96.2909 142.148 89.6358C142.148 82.9807 138.037 77.5857 132.965 77.5857C127.893 77.5857 123.781 82.9807 123.781 89.6358C123.781 96.2909 127.893 101.686 132.965 101.686Z",
    fill: "url(#paint60_linear_4_202046)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.6191,
    y: 42.1267,
    width: 89.8809,
    height: 95.0295,
    fill: "url(#pattern1_4_202046)"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4651 173.889L30.3849 176.044C30.3849 176.044 26.2816 176.338 27.454 181.726C28.6264 187.114 20.6152 294.096 20.6152 294.096L35.3674 292.137L32.8273 178.395C32.925 178.493 33.5112 174.672 35.4651 173.889Z",
    fill: "url(#paint61_linear_4_202046)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M208.389 173.889L213.469 176.044C213.469 176.044 217.572 176.338 216.4 181.726C215.227 187.114 223.239 294.096 223.239 294.096L208.486 292.137L211.026 178.395C210.929 178.493 210.44 174.672 208.389 173.889Z",
    fill: "url(#paint62_linear_4_202046)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7031,
    y: 7.8374,
    width: 145.568,
    height: 148.912,
    fill: "url(#pattern2_4_202046)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6113,
    y: 27.4312,
    width: 143.614,
    height: 144.994,
    fill: "url(#pattern3_4_202046)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.543,
    y: 68.578,
    width: 145.568,
    height: 147.933,
    fill: "url(#pattern4_4_202046)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4277,
    y: 83.2733,
    width: 143.614,
    height: 145.973,
    fill: "url(#pattern5_4_202046)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.4043,
    width: 142.637,
    height: 144.994,
    fill: "url(#pattern6_4_202046)"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3125,
    y: 33.3093,
    width: 143.614,
    height: 145.973,
    fill: "url(#pattern7_4_202046)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3125,
    y: 75.4358,
    width: 143.614,
    height: 145.973,
    fill: "url(#pattern8_4_202046)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.8652,
    y: 20.5732,
    width: 142.637,
    height: 145.973,
    fill: "url(#pattern9_4_202046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4_202046",
    transform: "scale(0.00925926 0.00471698)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_4_202046",
    transform: "scale(0.0108696 0.0103093)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_4_202046",
    transform: "scale(0.00671141 0.00657895)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_4_202046",
    transform: "scale(0.00680272 0.00675676)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_4_202046",
    transform: "scale(0.00671141 0.00662252)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_4_202046",
    transform: "scale(0.00680272 0.00671141)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_4_202046",
    transform: "scale(0.00684932 0.00675676)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_4_202046",
    transform: "scale(0.00680272 0.00671141)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_4_202046",
    transform: "scale(0.00680272 0.00671141)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_4_202046",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_4_202046",
    transform: "scale(0.00684932 0.00671141)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_202046",
    x1: 122.931,
    y1: 9.39555,
    x2: 122.931,
    y2: 399.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#2275A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_202046",
    x1: 124.739,
    y1: 9.39555,
    x2: 124.739,
    y2: 399.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#2275A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_202046",
    x1: 121.958,
    y1: 9.39564,
    x2: 121.958,
    y2: 399.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661802,
    stopColor: "#8DC5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5068,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#2275A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_202046",
    x1: 123.431,
    y1: 9.39564,
    x2: 123.431,
    y2: 399.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661802,
    stopColor: "#8DC5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2688,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5068,
    stopColor: "#2275A1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#2275A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_202046",
    x1: 121.934,
    y1: 351.904,
    x2: 121.934,
    y2: 234.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#0E3F54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_202046",
    x1: 121.934,
    y1: 330.877,
    x2: 121.934,
    y2: 247.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#0E3F54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_202046",
    x1: 121.935,
    y1: 357.075,
    x2: 121.935,
    y2: 221.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#0E3F54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_202046",
    x1: 85.4765,
    y1: 178.712,
    x2: 158.395,
    y2: 178.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0423187,
    stopColor: "#4693BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2128,
    stopColor: "#9ECEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3703,
    stopColor: "#77AFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#4693BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_202046",
    x1: 101.442,
    y1: 178.811,
    x2: 158.836,
    y2: 178.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#415458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0699593,
    stopColor: "#495D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3279,
    stopColor: "#617984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5738,
    stopColor: "#738D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8003,
    stopColor: "#7D9AAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#819EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_202046",
    x1: 121.929,
    y1: 256.245,
    x2: 121.929,
    y2: 99.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1108,
    stopColor: "#0E3F54",
    stopOpacity: 0.1958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2439,
    stopColor: "#0E3F54",
    stopOpacity: 0.4308
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3887,
    stopColor: "#0E3F54",
    stopOpacity: 0.6868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_202046",
    x1: 68.8377,
    y1: 124.795,
    x2: 174.894,
    y2: 124.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0241002,
    stopColor: "#76D8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D9FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#BFF5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#8FDCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_202046",
    x1: 121.924,
    y1: 124.855,
    x2: 68.9325,
    y2: 124.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8FDCC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_202046",
    x1: 99.0907,
    y1: 237.195,
    x2: 99.0907,
    y2: -198.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001878,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#4EBD96",
    stopOpacity: 0.6466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_202046",
    x1: 103.359,
    y1: 222.32,
    x2: 103.359,
    y2: -179.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001878,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#4EBD96",
    stopOpacity: 0.6466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_202046",
    x1: 143.792,
    y1: 420.021,
    x2: 143.792,
    y2: 17.7205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001878,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#4EBD96",
    stopOpacity: 0.6466
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9838,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_202046",
    x1: 121.936,
    y1: 239.254,
    x2: 121.936,
    y2: 102.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0105544,
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1883,
    stopColor: "#4FBD96",
    stopOpacity: 0.8203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5136,
    stopColor: "#4FBD96",
    stopOpacity: 0.4916
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#4FBD96",
    stopOpacity: 0.2068
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_202046",
    x1: 121.879,
    y1: 62.8448,
    x2: 121.879,
    y2: 10.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_202046",
    x1: 121.933,
    y1: 43.5105,
    x2: 121.933,
    y2: 11.5599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_202046",
    x1: 138.78,
    y1: 57.6133,
    x2: 138.78,
    y2: 11.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_202046",
    x1: 100.63,
    y1: 55.0065,
    x2: 100.63,
    y2: 17.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_202046",
    x1: 118.753,
    y1: 49.999,
    x2: 118.753,
    y2: 12.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_202046",
    x1: 121.921,
    y1: 128.034,
    x2: 121.921,
    y2: 65.9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02542,
    stopColor: "#0E3F54",
    stopOpacity: 0.0575936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0724486,
    stopColor: "#0E3F54",
    stopOpacity: 0.1641
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#0E3F54",
    stopOpacity: 0.2969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2132,
    stopColor: "#0E3F54",
    stopOpacity: 0.4831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_202046",
    x1: 121.921,
    y1: 122.903,
    x2: 121.921,
    y2: 57.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_202046",
    x1: 121.923,
    y1: 122.182,
    x2: 121.923,
    y2: 58.0787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.921 90.1302) scale(27.8438 27.9213)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#455E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9449,
    stopColor: "#476089",
    stopOpacity: 0.4272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9715,
    stopColor: "#4E668D",
    stopOpacity: 0.2209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#597095",
    stopOpacity: 0.0743436
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63789B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_202046",
    x1: 121.921,
    y1: 121.277,
    x2: 121.921,
    y2: 58.9838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AFB0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.921 90.1303) scale(27.0442 27.1195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#74BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238FA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.921 90.1303) scale(27.0442 27.1195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#619AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4_202046",
    x1: 112.793,
    y1: 104.132,
    x2: 134.09,
    y2: 67.3472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.033128,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#74BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4_202046",
    x1: 112.386,
    y1: 103.897,
    x2: 133.683,
    y2: 67.1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.033128,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#74BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4_202046",
    x1: 121.921,
    y1: 117.25,
    x2: 121.921,
    y2: 88.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5724,
    stopColor: "#74BED3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4_202046",
    x1: 121.923,
    y1: 170.3,
    x2: 121.923,
    y2: 136.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02542,
    stopColor: "#4EBD96",
    stopOpacity: 0.0575936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0724486,
    stopColor: "#4EBD96",
    stopOpacity: 0.1641
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#4EBD96",
    stopOpacity: 0.2969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2132,
    stopColor: "#4EBD96",
    stopOpacity: 0.4831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4_202046",
    x1: 121.923,
    y1: 167.499,
    x2: 121.923,
    y2: 131.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4_202046",
    x1: 121.923,
    y1: 167.106,
    x2: 121.923,
    y2: 132.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.922 149.611) scale(15.198 15.2403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#455E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9449,
    stopColor: "#476089",
    stopOpacity: 0.4272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9715,
    stopColor: "#4E668D",
    stopOpacity: 0.2209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9904,
    stopColor: "#597095",
    stopOpacity: 0.0743436
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63789B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4_202046",
    x1: 138.611,
    y1: 152.532,
    x2: 105.204,
    y2: 146.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#586568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AFB0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.924 149.611) scale(14.7615 14.8026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2375,
    stopColor: "#74BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238FA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_4_202046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.924 149.611) scale(14.7615 14.8026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#619AAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4_202046",
    x1: 116.94,
    y1: 157.253,
    x2: 128.565,
    y2: 137.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.033128,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4758,
    stopColor: "#74BED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4_202046",
    x1: 121.924,
    y1: 164.413,
    x2: 121.924,
    y2: 148.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#619AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5724,
    stopColor: "#74BED3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4_202046",
    x1: 121.649,
    y1: 45.0286,
    x2: 121.649,
    y2: 43.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECBE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088029,
    stopColor: "#B5D0E8",
    stopOpacity: 0.0883609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#CADDEF",
    stopOpacity: 0.4024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#D7E5F3",
    stopOpacity: 0.7096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#DBE8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4_202046",
    x1: 121.649,
    y1: 52.3375,
    x2: 121.649,
    y2: 50.4551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECBE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088029,
    stopColor: "#B5D0E8",
    stopOpacity: 0.0883609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#CADDEF",
    stopOpacity: 0.4024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#D7E5F3",
    stopOpacity: 0.7096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#DBE8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4_202046",
    x1: 121.649,
    y1: 173.847,
    x2: 121.649,
    y2: 171.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECBE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088029,
    stopColor: "#B5D0E8",
    stopOpacity: 0.0883609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#CADDEF",
    stopOpacity: 0.4024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#D7E5F3",
    stopOpacity: 0.7096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#DBE8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4_202046",
    x1: 121.649,
    y1: 128.345,
    x2: 121.649,
    y2: 126.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECBE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088029,
    stopColor: "#B5D0E8",
    stopOpacity: 0.0883609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#CADDEF",
    stopOpacity: 0.4024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#D7E5F3",
    stopOpacity: 0.7096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#DBE8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4_202046",
    x1: 121.649,
    y1: 181.156,
    x2: 121.649,
    y2: 179.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECBE6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088029,
    stopColor: "#B5D0E8",
    stopOpacity: 0.0883609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    stopColor: "#CADDEF",
    stopOpacity: 0.4024
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7069,
    stopColor: "#D7E5F3",
    stopOpacity: 0.7096
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9962,
    stopColor: "#DBE8F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4_202046",
    x1: 149.407,
    y1: 244.688,
    x2: 127.148,
    y2: 186.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DBBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6163,
    stopColor: "#85DBBC",
    stopOpacity: 0.6229
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    stopColor: "#85DBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4_202046",
    x1: 113.641,
    y1: 220.001,
    x2: 129.655,
    y2: 220.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00929612,
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4845,
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3F54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4_202046",
    x1: 121.371,
    y1: 247.161,
    x2: 121.371,
    y2: 188.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4_202046",
    x1: 114.153,
    y1: 244.455,
    x2: 71.6569,
    y2: 171.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DBBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6163,
    stopColor: "#85DBBC",
    stopOpacity: 0.6229
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    stopColor: "#85DBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4_202046",
    x1: 27.4441,
    y1: 215.342,
    x2: 92.1055,
    y2: 215.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#679FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4_202046",
    x1: 44.2185,
    y1: 264.691,
    x2: 44.2185,
    y2: 167.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB0D3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#6DB0D3",
    stopOpacity: 0.2863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6DB0D3",
    stopOpacity: 0.5222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#6DB0D3",
    stopOpacity: 0.7401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#6DB0D3",
    stopOpacity: 0.9461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DB0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4_202046",
    x1: 69.3219,
    y1: 326.933,
    x2: 69.3219,
    y2: 156.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4_202046",
    x1: 64.7888,
    y1: 206.6,
    x2: 64.7888,
    y2: 163.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB0D3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#6DB0D3",
    stopOpacity: 0.2863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6DB0D3",
    stopOpacity: 0.5222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#6DB0D3",
    stopOpacity: 0.7401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#6DB0D3",
    stopOpacity: 0.9461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DB0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4_202046",
    x1: 182.836,
    y1: 244.455,
    x2: 140.341,
    y2: 171.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DBBC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6163,
    stopColor: "#85DBBC",
    stopOpacity: 0.6229
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    stopColor: "#85DBBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4_202046",
    x1: 151.137,
    y1: 215.342,
    x2: 215.831,
    y2: 215.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#679FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4_202046",
    x1: 199.009,
    y1: 264.691,
    x2: 199.009,
    y2: 167.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB0D3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#6DB0D3",
    stopOpacity: 0.2863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6DB0D3",
    stopOpacity: 0.5222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#6DB0D3",
    stopOpacity: 0.7401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#6DB0D3",
    stopOpacity: 0.9461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DB0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4_202046",
    x1: 173.879,
    y1: 326.933,
    x2: 173.879,
    y2: 156.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1955,
    stopColor: "#2374A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#2374A1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#2374A1",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4_202046",
    x1: 178.44,
    y1: 206.6,
    x2: 178.44,
    y2: 163.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB0D3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    stopColor: "#6DB0D3",
    stopOpacity: 0.2863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6DB0D3",
    stopOpacity: 0.5222
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#6DB0D3",
    stopOpacity: 0.7401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#6DB0D3",
    stopOpacity: 0.9461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DB0D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4_202046",
    x1: 132.975,
    y1: 100.71,
    x2: 132.975,
    y2: 79.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4_202046",
    x1: 132.975,
    y1: 96.983,
    x2: 132.975,
    y2: 82.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4_202046",
    x1: 132.975,
    y1: 101.627,
    x2: 132.975,
    y2: 77.5656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0380484,
    stopColor: "#4EBD96",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4_202046",
    x1: 28.1378,
    y1: 294.109,
    x2: 28.1378,
    y2: 173.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    stopColor: "#7AC1D5",
    stopOpacity: 0.3358
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#8AC8DA",
    stopOpacity: 0.7709
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95CEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4_202046",
    x1: 215.782,
    y1: 294.109,
    x2: 215.782,
    y2: 173.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136,
    stopColor: "#74BED3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4261,
    stopColor: "#7AC1D5",
    stopOpacity: 0.3358
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#8AC8DA",
    stopOpacity: 0.7709
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95CEDE"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4_202046",
    width: 108,
    height: 212,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_4_202046",
    width: 92,
    height: 97,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_4_202046",
    width: 149,
    height: 152,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAACYCAYAAADtPKuRAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABERJREFUeNrs2U9PG0cYx/FnZnbXJjYJhJBeqGRFaStxzRtAqnroucrrCby0niq14kgOVYV8oFX44wDBXq93d2b6DDjChoamUk/t9yONV/b+OYx++8yzaxEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+GuGKfgbMZp4d8LM0k8gVJ+bpWgemKN4ky3CRaj+eZgWx2KgFgfhusMyBfcCZebzkoYbimRHOmR5uH0d82PMQhAxnyAsB2opVAPdvl+4+c70UC8SNkT8/KcwP5+KRag+2Q7Y4U2Y3LnOz7pui/HYjdO+fj92NESaJm+Xl8Swt3fbaxEq3KtSKxqkC5E8H0sxddNOnuddrUIuzsSHjlR2IrXpLfej29sS0nWoVoTqXpVKS15xLpmWqLzNqpWOyzaitV/qz309YKwTduR7MppMJnLR62nOJF7p2NykStGoL9Cl67pKDYfD617KrYurSsmDtb3W2oER862V+IMz8p02VC99LauZtYW7kix//951j47s6s7NNWjaqVTXFerNGxF9mjNfZJlJTXmtPVSn389sY1ZiMM+DNV9rMfpKW/LNKPFdDOFdW9uyzSZ1Ya11zpmV2+Xzf1+xqFSLGdjaSqkw/X7f2Jlk2iH1mhg2muBXfYwrbfCbPsQXYs0zzVFhjbGpidJcmW0mkkr1kHIyMU3Isk4hj30rzzUz1kicmGjqGEUfAKVo69pmXe5JQvXJ/nxerY5EznvnEus86noW25nEkD6NOdZnu/RWodJwnYiEaZEXre5LT3y6Gob4Vk8/0PGaCSVUKVF7qa/S7bCV2Hgf+o/Wfe2ruqqbi9qG36KY0re+q93TzNr4R8fZs1lZ1a7nwlNNlPc+TvX81/RT9FQfvZn/j1cOJMw0VKejCy95twrd4sTX4WDa+p/rYH6aNbpt6oPKy2lwTVV43zZPn/pqayuk1wp76TGS91T8oXxdquYvP/f3993GxoYre72sXxS5z7Li8qpZMVlbTBvjMl3pMpvN1lbzqvS+dnXddJ49a0Yi/lDXRK1UgVARqrvBun5PNRRx5elpVud51nXO1WXprOmb1EAVj6Lv6nr3+3Hrba9qn3z44E9OTsKPOzthN1U8QkWo7lar64qlwboaDt03g4H9cHbmnD7+XV5cmCdra9FrU56WyMfTqf+lLMOmBmpHA5UuQZWiUV++u0x6GX6TibSUvRiN5HwwCCfjcehkmZGikNOylFnbxqmO5vIyyKtXYWd7OxIoGvUHg5UC8nZvLx4eHoZt7ZV+HY18cXzcfhzp+/cvX7ZpfzqOQOGz85WWwzR2d3ftboy3Q79/3Ef7QE/1b84RlQkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA/6U8BBgBdevjDcamkmAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_4_202046",
    width: 147,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACUCAYAAACX4ButAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmJJREFUeNrs2M1qU0EYBuDvnJOQlEhTxLaIiF24E7zF1uvpTXgNLrrqomCltII20mpqcs440x9pa/qDC0F4HhiGMyer4c07k0QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/AOVLbhbSumP/amqKtkZYfqbAC3anyRYi9W2YGGQyly/v9if3+Pac3VXcwkTt4N0Hqa1PHZ3d5vdiKbMazfDJFDC9OCxX1010fL+fjMajZpRDlOZy3MsCBTuTLdb6UaQLkczmUz69Xhcd5NJNx6PZ3mtzaO7Nsq9Kbk/aab7mqk5OTlZGg6Hq8OIV2Uuz2VdM2mmxzRTfRmWZhIxyCFa69r2bV1VL7uUPtZN82EacTSOOLtsqKuW0kxZT5QWf8mak+h/701Xm7r3JufldV5abmfTg/58+DWexE9bJEyPcniYq2aU2yalWbTtJHVxWNWRyyrNciWl0/x+fd0+OeYePubOj7q94+NBxHClbtKL/H45H2Pfurb6FDE93lhZObt1EXfMCdPiX3N7OUxLh9EMBtE/np0O5/ms67XdfKU/mp6dxezHerQb1+5LwiRMD7VTfZBH73PUX6qonqZI89Xont/8W0Ar+WtgsXd5bF80Tbezs9Od5vY5XY354FnMylyey3p5Xz73zpYJ08KKzu2ymQOyk8f2dqSjo6PyE+78OLsa5bmsl/flc5taiYeOu62tVOf5ajTXxvna5XtXBHemRyXq3rqpLqpMIwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAf+2XAAMAoFb85FD+CQcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_4_202046",
    width: 149,
    height: 151,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAACXCAYAAAAcahlEAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA/1JREFUeNrs2k9rG0cYx/H5s7uy/sTxJgUjcGkhOoWSS++lb8LvJ3478YvwMRDSQg/RxaK0EBLc0AhbK2l3Z3amz0pyZMeOaeit/n7g0erP7mX46ZnZkZQCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNtphuBuMcYbY6S1jowMofovQdKfjVPcFAEjVF8VqKtBMu3DePP66TZUn4pgXWcYgi8GykwmKpGjlUryTb1V6/fG6/fb8dO3TZF0KtwIVBucM6l9eT6VkkCp6bo1xUdKNfI0qO0x0LG2EobgxpfMXHanzqYrpVJz+SxfT3eXYfKfXRskmKyxCNX1LvWLBOqxBKgv45IplaZzlZV91YlV1ZW02FmWNRKwckep6pYuf20BT6iw6lIPJxPTHY3azpRIq0qdVV3t3DdJknybWDvwTbOUAL67aJoPSadT9LZBClemTjoVWdpuGySjkZYwGSlbL5dZx9oH2tgnRumfJEwHidbToO1rCd2v0qqcJMkP1lOh2QRr1fXu+xR470N15c5Ny2Doi+nU9NPU7gwGaSx9Hk18Imf8IP3n+xhUEXUIcuZ7W6uPS6dK31dmb9ul6FRsKawdHx+vgnUgled5u9jWrqoyb/Qj18TvpHLnY1qHpuuasOdC05MLrNZyqgTp7Iy7aDrVXabSavJ+VFWllnVtV3vmShXGaLm3i6U8zLSJLrU2xl4WI52JUN22mIqHh1Hu/NSPq9lQqihiSFMnXem8DvoPpaMNIfblWEvE/syMOXdtsNptBLlGJsQ4luvfSB2SKaY/aUTx6OhIzSQcE6mmUcGH0NRFqHxQZ2Xjf1t4/3Lm/Mui8q+WPoznbvl3HWPlZZEuq/QwHKqwbLNJ1/r0Rb33Not1Mx4ru8zfJw87wySks6yfPNiZL2aDOoaBD03WdqXGN2Unyc57PVvowaDqyl3gcL0RutpdZ/OT6e9atv56qsLBZNj05cU77bUcow/G79ikqG1pVNnuI5im27O19d5JoPz+9qcauhTT39UZcNVd4s8SjtFINfO5BKXMXVGpupe6sk7cYtfmherbwoRkoepBdVFVTgLlZS0Wjvm3AqG6K1hqE6zuUPmP5Vvf2durH+/uSog+1HJHWMdOWe8slHu2v+/aKe93OX/cBoohxF3rKykjZV/HmL6JMTs9jZ3TuK72dft++3l73vPn0Sj++oJ/GaxVuF6sw2NPTk6Sti7DdHkOTYq7v69N1xcXSayfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/o/+EWAAX2LfFfRQoE0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_4_202046",
    width: 147,
    height: 149,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACVCAYAAABcvMgIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArtJREFUeNrs2c9qJEUcB/Dq6mR3NUFhIYsLHvaglzmKDyD4DD6P5nU27yDevHgT+uTBQy4zIYpxh8yf7i7rl5kwg5norgdB/Hyg6NSfuRTf/nV3JSUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAf0FjCx5XSnmwP03TFDsjTP8kQIf2pwiWML1LkJq9dihM902g9mRbcDBIsS/5p5TatNe2/bxtzWOPwv+rI1vwoFLfhyWf7IUmnGyqUfTH7dC4/9hTmbivLnet24WpfVlvtpuUnta/34/ry83Nd1edul3QGtVJmA5Wpklt0+m0/XUTnPeepfRindKruEY/xmN+8vg7lTCxCcfl5WVu2zbXJB2/Wa3O6thndeLLuEY/xmM+1iWB8s70V4GqQWlyzk19lj0pOX9U+vHzsWk+rY+yF3ViVhP0S51fxTpBEqa3cntbv/pzapfjUNNVozTWfNWMlXUdtz0ec3+n67o0DEMZnz8vwzjv50O5/r0ffvxtMX4f1+jH+N18XRfrEaYHLi4uajW6LX3fl6F+8i/6frVa9NP5Yvhh3Zdv4xr9GI/5WBfr43fsXjodDWyPBr6rN1f9ZMsf1M//p1dX7fz47KhfvDluc5OHsYxHz07XJ+urfnl2NtykNMxqqL7YnjU5CVeZNndUfQs6Pz9PVzUU9ZN//LgGZblcDjfL6frD9vT2tDmZxzX6MR7zsS7Wx+8ab1Eq05+r0/n2nOmrOLzsuvxkMmmOft7tUf8qlVXXlclkMtaHW6lvTOVrVUllOlCd7oIRAanvQWU2m42f1Ap0fb1r0Y/xmBck3qpCRfumlDgQyK9fl/a+RX877l8oHnPvlKqDJafZlDHVCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+8/4QYACNhkDu9rHVjgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_4_202046",
    width: 146,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAACUCAYAAAB4InCTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAkZJREFUeNrs2EFvEkEUAOAZdkuhFDXGSBprwsVLf4X/17/iuRcT24MJUYkeCO6WAussXdptAFMPHky+L3nZCTNcXh5v3hICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8M9FKdivqqq9uYkxVrKjkP6mgA7lplJQuzpSsFNE8cOHTV5ik5923O8d6lg6kiKKTT72xbYT7YTOpCP9qYjqvGSTScjTcxPNOtt2pm3oTDrSvkJqX2N10Ryl6DbHFiluU6xSrFuhKzW/Nh5+VPH6+rrT7/ezXm/U7fXCy+PjcFZv3tyESVmGH2X5dVEURRiPx1XzHVebq+2xy8vLmOd5HI1GMX8ejrMsvF2u1+/rqNf1Z5u9dKY+K2M60n4XF5vHdBriYFBki273tLMKb+rP1p3VaadYZNN5P4bzc7lSSE8xDfPqZL0qb4sYw/e7OSoUWazW9V4Ir6TIsH1w2N4M2ddpyO6nWM5mvXIZz1br6l19JuvET728muTDYVmkgXvcGroN2wpp71vbl1Q3vdStZ9/mJ0VcDesz/SqbDV8PfpUhLM8fv7l5a3O17dZUHeVdgSxP42D+Iv9Z1hvL5bNVWqyavcrbGge7UopOiizFUYru1dVVLz030ay7zV7WnNXR2VtI7WLKP94VzSaadd4uIoX0wP9I22HxYc7ZXlvrz61/sFvr+2vNbGTYfsrw/ZSiAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID/zG8BBgB0egf+KbKmhAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_4_202046",
    width: 147,
    height: 149,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACVCAYAAABcvMgIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqdJREFUeNrs2c9uG1UUB+B7Z/wncUXSUIQ3SEUoqy4AqSsepM+T+Hl4CPoCrJCyyiISSCgUWpJmbI+dmct14oZxmoSwYYG+TzryJGNvrn5zzkkcAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMB/IDqC+6WUNs4nxqsfk5O5W+EIPn7AViFaB2mjDg8Pu/fg4U60rmJdZa7eqn64fi079wTqlp4j+GikxTsqfL5+W6dWn1mNPmPPmLt3h1xVcXx8XObXm9rJdXJydV10g6ZDWcDv6ko3QepU+Wfu3k/z9bt3oVnshctxCE3+fduppDsJ011hugnRqi4uLrb7/f7TYjgcNfP5WV3XZ/P57mI2Ds2Xf4cqCZQxt+H7HKYfN/ek/mAweBZ7vW9C237X29p63t/d3R6PQ9G7tU8hTBte5XrZ2ZuqEAZtUYwvm/Rtk8LX9bJ5Pq3rT/LYK3PbinmnEiR/zT3OtKpiLMsitkVIbQplDNttjMOL8/Oi3NlxQML04JgLX113p3R6GsJo9GT5+6L6o02XP4Uibvdj+HkwLM+fNE2Tu1ba39+3dFvA/3kB/yWPsvnbt/1eMxzVsd1dxliMimX1bG/v/TyExSxYwHWmR+RqVV/kkPxa15fn/U+r4Wdhvjg7i22TmvlpaPICvhEiQbKAb7bn6zB8qKv/H1VV1eQgLfPTVi+m03prOl3OZifN0fp+Hotp4uiMuQdGXQj3fJ1ydHQUZi9epPf5rW9y5VClA13JmLuvO60DlTojL75+/eGB+y28yWF6te5IgqQzPaZH5VRdX00mk3gVmxuTcHBwkDqjEWH6N+eTbh+XEAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA/8JfAgwAKBcZR0ZF1xMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_4_202046",
    width: 147,
    height: 149,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACVCAYAAABcvMgIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAstJREFUeNrs2V9rI1UYB+Azk0ymTe1SYSsEKqxLLgXBfIH9aP0++yVy4Z30dhWJJaAS26zs6rqdJpk/nskmbrFJWb0QxOeBl5akvTn85veetCEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/AsSR7Bf0zT3zidJksbJCNM/CdCu82mEarfUEewMUvL8eUjH4/X53J1kO7ta6/+u6wjuB6mdp09Denh4r5maO9P+jobSTPvX/ng8XrfQaBTSR49CZzYL3dm7h66zmfTi4iLVUO5MD7XSdtLpdNrJ8yfpYLB+2LpvYoiOQyjn83m1WCyqs7OzKr5eb6bRTtbczodrMgnp0VGeZoN1Cx3E8Hx8kOf9+P3rPM9/Oz09XdxZdYl1J0z7WjrpdkMSKynphZAtQ3jczfPPkzo8jh31TZZlk/gz5aaRtk2mldyZ7nvx4l2YOi9fprGWenVZDsqyHK2a6stVVX3W6bTbbt1YiSuCMH2w4uYmvalCd1HFhqrqbFHWx2WSHLRndnV1JUgu4A9ewNef4qaxeY7moVvXv/fr4/zTsqq+6CRNP8vS7+M++65XFL8Uxcny7dtJNRwOK5dwzbQzU+2U7ZyGutf7aFEl2c+rNP16WdZf1bfNt6s8f706OYn5+rFZLpfNeDx2asK0P1DD2DTx41q9XIayfxje9I56P2Wd+ofi1e2reClfxPeq29uzuiiKZj6fN1rJmvvrntumIYldk34Spz8NafdJvIzH1wbxjdlsFqqqatog/ToM9Wiz3oRJmPbdm/4M1LPNJ7bJ9owmk9CutraRRqORIFlzDzxV70PRPHv/1+06rr1qPfGyfX19XV9eXgoSH95Q7Zyfn6fx667x/zhr7u+fTftvkgcaDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4T/tDgAEAIyArVuXwY9kAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_4_202046",
    width: 146,
    height: 149,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAACVCAYAAACzfqM2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmxJREFUeNrs2dtKG0EYB/DZ7CZq1JtCKD1BL7zyJer79iHEZyjkJoUKhZaa0gOI5rDJdCZuDhotttCb8vvBRyY7e/Xxz85kNgQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgnyu04H4xxnt7UxRF1B1B+pMAPdSbKFDbWlqwFaLi7U1fiqY/m7Wae+iJhRDlcLRSlamqVO3BYLCTPhfVjNvNXNncK0yWtu0n0UYtnkCfUz1repTGMY3nYV1xWZY5QbobpNUyNhwOq06n066qqpPvqet6kkx7vV4d7gRKkARpM0iLAJ2HUO6l2g2hk+pJWdfP8z2zqvo0CuFbqsl1+vo61TJMgmSzfUs//bCqVE9vPndSOl6FVutNrjzO15q5ou9HeEulBWvHzefXFJL99FSaz2aHdShe5Gt53CrLMs+91CpBevRyl7JzWdejYha/L76XxeigLOc6I0iPzE/aMg2Hcbbbm17N6uE0hnd5ol2E4d5kZxpHwxh6veU/NgTp/hC9T7Vf1/PpYZgUV8WX8fV8nCc7e60f026Y1Jf1PN9ztP77jyBthykFZH4+HueNdL3f7V4W05+jPNHtHtQpUbPxeDw/Wp8jwe1jkOXJ9unp6c2pdow7H2Lc/RjjXq48Htyccrebe1ob508aqAXNo+j2y9pV9fv9xfXj4+PVSfZGeXnbcI60TM86EMuQLA4bLy4uFhW2X40IkT3Sb8OUl7hVqM7OzhZPpJOTk7hxX7BH4m+Wf1sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP4TvwQYAIwgGy4j/ZeUAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/RocketIcon.9460d739b358610dec19610f177d35ab.svg";
export { ForwardRef as ReactComponent };